module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "P_Heading_1_h14"
  }, [_c('span', [_vm._v("Chapter 2")])]), _vm._v(" "), _c('p', {
    staticClass: "P_p4"
  }, [_c('img', {
    attrs: {
      "alt": "img3.png",
      "src": "image2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "P_p16"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1.17em"
    }
  }, [_vm._v("T")]), _c('span', {
    staticStyle: {
      "font-size": "0.92em"
    }
  }, [_vm._v("HE")]), _c('span', {
    staticStyle: {
      "font-size": "1.17em"
    }
  }), _vm._v("hospital wanted to keep me overnight in case I had a concussion, but I’d had enough of them in my life to know the difference. I wasn’t nauseous, nor did I have a splintering headache behind my right eye, but most of all—and this was the clincher—everything was the correct color. My vision wasn’t blurred or spotty, so against medical advice, I signed myself out.")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("I was walking out of my room when I saw Joaquin and the others at the nurses’ station.")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“Hey,” I called to them.")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("Joaquin levered up off the counter where he was leaning and jogged over to me, Benny and Andre close behind him.")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“You all right?” he inquired, looking worried, his gaze met mine, and when he reached me, his hand went on my shoulder. It was funny, but it seemed like he honestly cared.")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“Yeah, I’m good.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("He didn’t look convinced. “So where is your crib, man?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“Brooklyn,” I said as I was programmed to.")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("He shook his head. “Nah. Now you live in Musa’s old place. I had it all cleaned up for ya.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“Oh no, Boss, you don’t gotta do that.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“Yeah, he does,” Benny assured me.")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“Yeah, I do.” Joaquin chuckled as Andre slid his arm around my shoulder.")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“Come on, man, let’s go. We’ll go get your shit first.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“You look like ass.” Benny scrunched up his face like I smelled.")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“I’ll be fine.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“How many stitches?” Joaquin wanted to know.")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“Only fifteen or so,” I lied. “It’s not a big deal.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“I said diversion, buddy, not World War Three.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“I think Pedro was the one with the knife.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("Joaquin agreed. “Yeah. I think he’s been pissed at you since Musa.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“Me moving into his place ain’t gonna help,” I said frankly.")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“I’ll take care of Pedro.” Benny smiled in that sort of sinister way he had. It was very cat-that-swallowed-the-canary.")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“Oh no, I didn’t mean—”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“No, no,” Joaquin soothed me. “Not like that. Calm down.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“I just don’t wanna cause a problem.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“No, man. You fix them, as far as I can tell.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“That shit was federal,” Andre reminded me, his voice low, easing me sideways so I had to give him some of my weight. “That prick Evanston brought a guy to us with a marshal on his ass.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("I nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“Did you know that Evanston shot some kid in Chicago?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("Yes. “No, I didn’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“Yeah, he’s gettin’ life for that shit, or a needle in his arm.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“If he doesn’t roll.” Benny smirked. “You always gotta figure on that shit with guys like him.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("Joaquin shook his head. “That’s Modella’s problem. I already called him.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“Too bad we didn’t get the name of the marshal,” I fished. “We could’ve taken care of that too.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“Oh fuck that,” Andre grumbled. “We ain’t messin’ with no goddamn marshal. He wasn’t even there for us; all he wanted was that piece of shit Evanston.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“Nobody needs that kind of heat,” Andre chimed in.")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("I was glad to hear Sam wasn’t even on their radar. “Okay.” I winced. “Let’s go before all my pain meds are gone.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“I got shit for pain,” Benny assured me. “Just say the word.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("Even though I was cleared to do drugs if necessary to maintain my cover, I didn’t think taking anything stronger than Tylenol for stitches was what anyone behind the scenes on the task force had in mind.")]), _vm._v(" "), _c('p', {
    staticClass: "P_p16"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1.17em"
    }
  }, [_vm._v("T")]), _c('span', {
    staticStyle: {
      "font-size": "0.92em"
    }
  }, [_vm._v("HE")]), _vm._v(" apartment was small and clean, in an older building that had been restored. It was not far from the theater district, close enough to walk, if a twenty-minute stroll was something you were up for. It was like staying at a hotel, and Joaquin suggested I get either a plant or a cat. Benny suggested I find a woman, instead, and forget anything else. Andre went over the good places to pick up pastries, tapas, or to get a drink.")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("It was nice that, on his way out, Joaquin squeezed the back of my neck and ordered me into bed. He gave me the keys: one for the security door outside, one to get from the foyer where the mailboxes were into the building, and the last one for the apartment.")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“I don’t wanna see your face ’til at least Monday.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("As it was Thursday night, that gave me a nice three-day weekend. Maybe I could fly back to Chicago and see Aaron Sutter. “Okay,” I agreed.")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("Once they were gone, I called Agent Chun, reported what happened, and then hung up. I promised to talk to him no later than Tuesday. I thought about taking a shower and changing out of my bloodied T-shirt but just couldn’t muster the energy. Both my suit jacket and shirt had been sacrificed in the line of duty, first pierced with the knife used to stab me and then shredded by the paramedics. Many articles of clothing had been lost that way over the years. I had to add up what the Chicago PD owed me in dry cleaning and replacement wardrobe one of these days. It had to be in the thousands.")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("Lying down on the couch, I picked up my own phone from the coffee table and called Aaron.")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("He answered on the second ring. “Duncan?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“Yeah. How did you know?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“I—” He coughed. “—put your number in my phone.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("It was nice to hear. “So,” I said, my voice low and full of gravel. “How are you?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“I’m good,” he said quickly. “You?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“I just got stitches.” I grinned because, God, he sounded good. “So I’m a little beat to shit, if you wanna know the truth.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“You got—who hurt you?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“I’m a cop. You know how it is.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("He cleared his throat. “I don’t, actually.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("I grunted. “It happens. I’ll live.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“Yeah?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("Why did he sound scared? “Are you all right?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“I don’t want to freak you out.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“Why would you?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“I, uhm,” he hedged, “I’m in New York. I have been for a week.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("There had to be more.")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“Duncan?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“Yeah, still here.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“Are you—is that freaking you out?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“You do business all over the world, yeah?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“So you probably hafta come to New York a lot, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“I do, yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“I guess I’m not getting why you being here would be weird.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“I just”—his voice cracked—“didn’t want you to think I was stalking you or something.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“Oh, wouldn’t that be something,” I mused.")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“Something?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“Yeah, I mean, that’d be cool, right? How many guys could say that Aaron Sutter was following them around? I should be so lucky.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("He whimpered.")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("The sound about shredded what little control I had left. Hurt and tired, with the last of my buzz wearing off, I was damn needy. “You maybe wanna see me?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("Silence.")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“Aaron?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“Yes, please,” he murmured. “I would love to see you. Where are you? I’ll come get you.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“No. It’s not safe. You tell me where you are, and I’ll come to you.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“How ’bout this,” he said shakily. “You walk one street over from where you are, and I’ll be there in a car in ten minutes to get you. Deal?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“What if I’m not in the city?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“Fine. However long it takes,” he huffed out. “Where are you?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“Tenth Avenue and 49th Street.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“Oh man, I’m like minutes from you. I’m staying at The Pierre on 5th.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“I don’t know that place. Is it fancy?” I teased.")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“It is.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("Of course it was. “Okay. Will they let me in?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“You’ll be with me.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“True.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“So—are you working?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“Yeah.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“I see.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“But not until Monday.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“Oh?” His voice rose, and I could hear the reprieve and the happiness.")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("I made a noise that didn’t quite qualify as communication.")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“You think you’d want to stay with me a couple days?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“Yeah. Ya know I was thinking of flying back to Chicago just to see you,” I said without even thinking of how scary psycho it sounded. “Awww shit.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("Several long moments passed, but I was too panicked to speak. I had no filter because of everything, and now I would pay for it.")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“You were thinking of returning to Chicago for just two days?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“Well, three actually,” I corrected him. “But, yeah.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("Quick, sharp exhale. “Okay, you win. That’s like one of the nicest things anyone’s ever said to me.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("It was? “It is?” I was baffled. “Shit, who’ve you been hangin’ out with?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“People who like my money,” he said, clipping the words. “I’m leaving now. Can you walk?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“Yes, I can walk,” I grumbled.")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("He chuckled. “Hurry up, all right?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("The phone went dead, and I realized he had basically ordered me to get my ass in gear. And though I started to ache, I got up anyway to change into some clean clothes.")]), _vm._v(" "), _c('p', {
    staticClass: "P_p16"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1.17em"
    }
  }, [_vm._v("I")]), _c('span', {
    staticStyle: {
      "font-size": "0.92em"
    }
  }, [_vm._v("T")]), _c('span', {
    staticStyle: {
      "font-size": "1.17em"
    }
  }), _c('span', {
    staticStyle: {
      "font-size": "0.92em"
    }
  }, [_vm._v("WAS")]), _vm._v(" a nice car: some kind of big, fancy black BMW sedan with tinted windows, a shiny paint job that reflected all the city lights, and sparkling chrome. When it rolled up to the curb beside me, I stood there looking at my reflection for a minute before the window rolled down and I was looking at Aaron Sutter.")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("The luminous aqua eyes, fringed with long gold lashes, stared out at me from the darkness of the car. I nearly swallowed my tongue. “Hi,” I said lamely.")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("The door opened. “Get in.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("The driver was suddenly there beside me, holding out a hand for my bag. I passed it to him as I saw the trunk open, and then got in, closing the door behind me. When I turned to Aaron, he gasped.")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“Aww, it’s not that bad.” I grinned, trying to sound normal and not like my heart was about to pound its way out of my chest.")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("His brows were furrowed, and his eyes glinted in the low light. “It’s worse, actually,” he assured me, reaching out to put a hand on my cheek.")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("I leaned into his touch. I couldn’t help it.")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“Jesus, I so get this now,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“Mmmm?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“Yeah. The whole comforting-a-policeman thing,” he clarified. “No wonder I never had a chance with Jory. This is scary addictive.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("He shook his head, then told the driver we were ready to go.")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("As the car pulled away from the curb, I covered his hand with mine and slid it down my cheek before turning it over to kiss his palm. “I’m really happy to see you,” I said, watching him, memorizing every reaction as I leaned close, unable to resist the temptation of his ear. Gently, I sucked the soft flesh just past my lips and nibbled slowly around the curve of his lobe.")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("He shivered hard and tilted his head away, just barely. I followed the sway of his body, moving my mouth to the tender skin behind his ear and then trailing down the side of his neck, kissing and suckling. Using the cord of muscle as my guide, I licked and finally bit, not enough to hurt, just enough so he could feel my teeth.")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“Duncan.” He jolted, pulling away.")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“Shit, I’m—”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“No,” he stopped me. “I just don’t want to attack you right here in the car. It’s sort of tacky, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“Is it?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("He scowled. “Let me get you to my suite. You can take a long, hot bath, I’ll order room service, and we can sit out on the terrace and take in the view of Central Park.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“And?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“And after I take care of you and make sure you’re fine—then I’m all yours.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("He was used to giving orders; I wasn’t used to taking them. “Screw that,” I growled, cupping his face in my hands and pulling him close for a kiss.")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("I didn’t even have to press: he opened for me the second our lips sealed together. Sliding inside his wet heat, I rubbed my tongue over his, tasting, reminding him I had done this before. He melted against me, pliant and willing, his moan deep and throaty. He had no idea how much I loved surrender noises, how thick and aching my cock suddenly was, swelling almost painfully inside my jeans.")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("When he kissed me back, grinding our mouths together, stroking my tongue with his, sucking on my lips, hands fluttering on the side of my neck, I knew he was mine for the taking.")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“You taste good,” I barely got out, shifting sideways, tugging him over into my lap so he straddled my hips. He tried to untangle himself, but I kissed him, hard and rough, and drained the fight out of him.")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“Duncan,” he moaned softly when I finally let him breathe, shoving his groin against my abdomen, needing the friction, his hands gripping my chest as he began a slow, driving rhythm. “I missed you… I….” He couldn’t finish, his words stilted.")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("I found that incredibly hot.")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“This isn’t me,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“I never… need.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("He was about control. I understood that. He was rich and powerful; Aaron Sutter was not the kind of man who should get off on rubbing his cock against my abs. But he was, and the hunger and the yearning were his undoing. He was coming apart in my arms, and I wanted to see it, to feel it in my hands even more. I made quick work of his belt, and I had the stays of his dress pants open and the zipper down seconds later.")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“You’re hurt,” he said, his voice cracking as he puffed air over my skin, wet and hot.")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("I slipped his cock from under his briefs, and wrapped my hand around the long, thick length of him, loving the feel of the silky skin, smearing the leaking precome over the flared head, and slowly, sensuously, jerking him off.")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("He shoved forward into my grip and barked at the driver at the same time. “Park the car!”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("When you were worth billions, I guessed, people just knew what you meant. But I was only peripherally aware we had gone in a different direction. I was much too focused on the breathtaking man in my lap, writhing with need, pistoning in and out of my fist.")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("I lifted my left hand to his lips. “Suck on my fingers. Get ’em real wet.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("He understood, opening instantly, taking them deep into his mouth, coating and laving my index and middle fingers until, when I eased them free, they were slick with saliva.")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("We stopped, and I heard the door open and close, was aware of the sound of the power locks and then the footsteps of dress shoes over concrete.")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“Lift up,” I ordered, and he rose, leaning forward and curling his back so it grazed the roof of the car instead of bumping it as I put my hand down the back of his trousers.")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“I never… I don’t… I….”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("He was good, proper, and only sinful behind closed doors. He was Aaron fucking Sutter. He didn’t shed inhibitions in public; it was unseemly. The idea that he was so far gone all his reticence sailed right out the window, was just about the hottest thing I could think of.")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("I squeezed his shaft as I pressed my middle finger inside him. He bucked forward, and it hurt me—my ribs, my side—but only sharply for a second and not enough to stop. His head thrown back, the arch of his spine, how he was biting his bottom lip: he was a vision, and I couldn’t be bothered with my comfort. All that mattered was him.")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("I dragged my fingertip over his prostate, and he babbled something incomprehensible as he pushed in and out of my fist. “Is it good?” I prodded, my voice rumbling out of me because watching him was a gift.")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("His mouth was open and all I heard were gasps as I added a second finger, scissoring, breaching the tight muscles, feeling the give as they loosened and I pressed deep inside the tight, hot channel.")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“Duncan, please,” he begged me, hands clenched on my shoulders, taking my fingers to the knuckles, rising up and shoving back down, over and over.")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“Turn around and I’ll shove my tongue up your ass.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("His moan was raw and strangled; he had nearly climaxed with just the suggestion.")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“You want me to do that? Huh? Aaron? You want me to rim you ’til you scream?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("He shuddered and shot come onto the front of my gray T-shirt, yelling my name as his orgasm rushed through him, freezing all his muscles.")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("I didn’t move. I let the aftershocks roll through him, felt the shiver begin as semen seeped from his slowly softening dick.")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("His hands relaxed their grip on my shoulders, and he bent down, burrowing into my chest as I eased my fingers from his spasming passage. His sharp inhale, his arms wrapped tight around my neck, and his face in the hollow of my throat changed passion to possession in an instant. I had the overwhelming urge to demand no one ever be allowed to see him like this except me. I wanted to tell him he belonged to me, but it was too fast, and I was afraid it would scare him off.")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("I didn’t want him to run. More importantly, I didn’t want him to order me to stay away from him.")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“Get your dick out so I can suck it,” he directed softly, still twitching, his body overstimulated, overly sensitized, and quivering with the sensation of coming down from the euphoria of his orgasm.")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("“Just let me hold you, all right?” I said, gathering him in my arms, pressing him tight to my chest, the pain of no consequence, and I kissed his forehead. “Can I be shelter for just a sec?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p17"
  }, [_vm._v("He gave me his weight, sort of melting over me, and I sighed deeply. He was vulnerable, and I was there for him. It felt good to not only be wanted, but needed too.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34f5746a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0007.vue
// module id = 75
// module chunks = 0